import React, { forwardRef } from 'react';
import { 
  Snackbar, 
  Alert as MuiAlert, 
  Slide 
} from '@mui/material';
import styles from './Toast.module.css';

// Custom Alert component with styling
const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

// Slide transition for the toast (fora do render: recriá-la a cada render remonta a transição)
function TransitionUp(props) {
  return <Slide {...props} direction="down" />;
}

/**
 * Toast notification component for displaying success and error messages
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether the toast is visible
 * @param {function} props.onClose - Function to call when the toast is closed
 * @param {string} props.message - The message to display
 * @param {string} props.severity - The severity of the toast (success, error, warning, info)
 * @param {number} props.autoHideDuration - The duration in ms before the toast auto-hides
 * @param {string} props.position - The position of the toast (top, bottom, etc.)
 * @param {Object} props.sx - Optional extra styles for the Snackbar (e.g. distance from the top)
 */
function Toast({ 
  open, 
  onClose, 
  message, 
  severity = "success", 
  autoHideDuration = 6000,
  position = { vertical: 'top', horizontal: 'center' },
  sx
}) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={position}
      TransitionComponent={TransitionUp}
      className={styles.snackbar}
      sx={sx}
    >
      <Alert 
        onClose={onClose} 
        severity={severity} 
        className={styles.alert}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

export default Toast;